import { render, staticRenderFns } from "./embedded-version-form.vue?vue&type=template&id=7e9beff5&scoped=true"
import script from "./embedded-version-form.vue?vue&type=script&lang=js"
export * from "./embedded-version-form.vue?vue&type=script&lang=js"
import style0 from "./embedded-version-form.vue?vue&type=style&index=0&id=7e9beff5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9beff5",
  null
  
)

export default component.exports